import { render, staticRenderFns } from "./energyWorkshops.vue?vue&type=template&id=00bf0b5c&"
import script from "./energyWorkshops.vue?vue&type=script&lang=js&"
export * from "./energyWorkshops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports